
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/AkkhorLayout";
import List from "../../component/List";

export default function ListCampaign() {
    let params = 'orderby=id-asc';
    const columns = [
        { name: "id", label: "ID" },
        { name: "title", label: "Tên chiến dịch" },
        { name: "budget", label: "Chi phí" },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value == 1) return "Hoạt động"
                    if (value == 0) return "Ngừng hoạt động"
                    return null
                },
            }
        },
        { name: "author", label: "Người tạo" },
        { name: "datecreate", label: "Ngày tạo", }
    ];

    return (<AkkhorLayout idrole="campaign">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Chiến dịch
                </li>
            </ul>
        </div>
        <List name="campaign" idrole="campaign" params={params} title="" defaultLimit={50} serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
